











import Vue from "vue";
import { Component, Inject } from "vue-property-decorator";

@Component
export default class PageStatisticsComponent extends Vue {
  async created() {}
}
